import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  ArticleBounds,
  clampLineCount,
} from 'featureSliced/shared/utils/quantityBounds'
import { IBucketProduct, initialState } from './types'

// Call sites that know the live catalog product pass its ClickCollectOrderMin/Max along so
// the store itself can never take an article's summed count past the max (split lines with
// different kitchenInfo included). The bounds ride the ACTION only — they are stripped
// before the line is stored, so redux-persist never keeps a stale copy.
export type AddProductPayload = IBucketProduct & {
  articleBounds?: ArticleBounds
}

const splitPayload = (payload: AddProductPayload) => {
  const { articleBounds, ...line } = payload
  return { articleBounds, line }
}

const clampedCount = (
  state: { products: IBucketProduct[] },
  payload: AddProductPayload,
  requested: number,
  previous: number
) => {
  const { articleBounds } = payload
  if (!articleBounds) return requested
  return clampLineCount(
    requested,
    previous,
    articleBounds,
    state.products,
    payload.productId,
    payload.uniqueId
  )
}

export const QRMBucketSlice = createSlice({
  name: 'bucket',
  initialState,
  reducers: {
    addProductToBucket1(state, action: PayloadAction<AddProductPayload>) {
      const { line } = splitPayload(action.payload)
      const count = clampedCount(state, action.payload, line.count, 0)
      if (count <= 0) return
      state.products.push({ ...line, count })
    },
    addProductToBucket(state, action: PayloadAction<AddProductPayload>) {
      const { line } = splitPayload(action.payload)
      const doesExist = state?.products?.find((product) => {
        return product?.uniqueId === line?.uniqueId
      })
      if (doesExist && line.menuItems) {
        state.products = [
          ...state.products.map((el) => {
            if (el.uniqueId === line.uniqueId && line.menuItems) {
              const requested = line.count ? line.count : el.count + 1
              return {
                ...el,
                count: clampedCount(state, action.payload, requested, el.count),
                // menuItems: [
                //   ...(el.menuItems ? el.menuItems : []),
                //   ...action.payload.menuItems,
                // ],
              }
            }
            return el
          }),
        ]
      }
      if (doesExist && !line.menuItems) {
        state.products = [
          ...state.products.filter(
            (el) => !doesExist || !(el.uniqueId === line.uniqueId)
          ),
          ...(line.count
            ? [
                {
                  ...line,
                  count: clampedCount(
                    state,
                    action.payload,
                    line.count,
                    doesExist.count
                  ),
                },
              ]
            : []),
        ]
      }
      if (!doesExist) {
        const requested = line.count ? line.count : 1
        const count = clampedCount(state, action.payload, requested, 0)
        if (count <= 0) return
        state.products = [...state.products, { ...line, count }]
      }
    },
    removeProductFromBucket(state, action: PayloadAction<string>) {
      console.log(' action:', action)
      state.products = state.products.filter(
        (el) => el.uniqueId !== action.payload
      )
    },
    clearBucket(state) {
      console.log(' bucket is cleared from reducer')
      state.products = []
    },
  },
})

export default QRMBucketSlice.reducer
